






















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {UserStore} from '@/store/user-module';
import {DateTime} from 'luxon';
import {successButtonColorClass} from '@/utlitities/color';
import { dateGreaterEqual, dateSmallerEqual } from "@/utlitities/helper";

@Component({
  inheritAttrs: false,
  components: {},
})
export default class StDatePicker extends Vue {
  @Prop() value!: string;
  @Prop() inputClass!: string;
  @Prop() disabledDates!: any;
  @Prop() disabled!: boolean;
  @Prop() minDate!: string;
  @Prop() maxDate!: string;
  @Prop() clearable!: boolean;
  @Prop({default: 'date'}) type!: string;

  get getValue() {
    return this.value;
  }

  get successButtonColor(){
    return successButtonColorClass(UserStore.userSettings.successButtonColor)
  }

  get datePattern(){
    return (UserStore.userSettings.datePattern ?? 'dd.MM.yyyy').toUpperCase()
  }

  get pickerLocale() {
    return {lang: UserStore.userSettings.language};
  }

  changedDate(val: any) {
    if (!DateTime.fromFormat(val.target.value, UserStore.userSettings.datePattern).isValid)
    {
      this.input(this.value)
    } else {
      this.input(DateTime.fromFormat(val.target.value, UserStore.userSettings.datePattern).toISODate());
    }
  }

  @Emit('input')
  clear():any{
    console.log('clear')
    return null;
  }

  @Emit('input')
  input(val: string) {
    if(this.minDate){
      if(dateSmallerEqual(DateTime.fromISO(val),DateTime.fromISO(this.minDate))){
        return this.minDate;
      }
    }

    if(this.maxDate){
      if(dateGreaterEqual(DateTime.fromISO(val),DateTime.fromISO(this.maxDate))){
        return this.maxDate;
      }
    }
    return val;
  }
}
